module.exports = __webpack_public_path__ + "img/sendIcon.6755fa82.8e88ebda.svg";